export default "__VITE_ASSET__283cb353__"